<template>
    <div>
        <eden-information-card>
            <template #content>
                <div class="py-2 px-2">
                    <p class="text-bold">Customer Feedback</p>
                    <div class="is-flex gap-1 is-align-center mt-2">
                        <el-rate v-model="rate" disabled class="w-42" />
                        <p class="font-base text-base">
                            {{ review }}
                        </p>
                    </div>
                    <p class="font-base text-base mt-2">
                        {{ formatText(description) }}
                    </p>

                    <el-tag :class="'font-base text-base'" v-for="(tag, index) in tags" :key="index" class="mt-2">{{
                        formatText(tag)
                        }}</el-tag>

                    <p class="font-base text-base mt-3">
                        {{ formatDateAndTime(dateAndTime, "do m,y",) }}
                    </p>
                </div>
            </template>
        </eden-information-card>
    </div>
</template>

<script>
export default {
    name: "OrderReviews",
    props: {
        rate: {
            type: Number,
            default: 0,
            required: true,
        },
        tags: {
            type: Array,
            default() {
                return [];
            },
        },
        review: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        dateAndTime: {
            type: String,
            default: "",
        },

    },

};
</script>

<style scoped>
.w-42 {
    width: 42%;
}
</style>